import { BuyersDropdownData } from 'src/app/auth/auth.interface';
import { AuthService } from 'src/app/auth/auth.service';
import { MultiBuyerSession } from './multi-buyer-session';

export class MultiBuyerIdentity {
  constructor(private readonly _auth: AuthService) {}

  async fetchBuyersIds(
    multiBuyerSession: MultiBuyerSession
  ): Promise<number[]> {
    if (!this._auth.isLoggedInAsMultiBuyer()) {
      return [];
    }

    const result = await multiBuyerSession.buyers(this._originId);

    return new BuyerCollection(result).ids;
  }

  private get _originId(): number {
    const selected = this._auth.selectedMultiBuyerCompany;
    return (selected?.parentCompany || this._auth.userCompanyId)!;
  }

  get defaultSelectionId(): number | undefined {
    return this._auth.selectedMultiBuyerCompany?.id;
  }
}

export class BuyerCollection {
  constructor(private readonly _buyers: BuyersDropdownData[] = []) {}

  get ids(): number[] {
    return this._buyers.map((buyer) => Number(buyer.id));
  }

  get hasItems(): boolean {
    return !!this._buyers.length;
  }

  find(buyerId: number | null): any {
    if (!buyerId) {
      return null;
    }
    return this._buyers.find((buyer) => buyer.id === buyerId) || null;
  }
}
